export const enterpriseRoutesViewLoader = () => {
  return import(/* webpackChunkName: "enterprise-admin-dashboard-view" */ 'app/scripts/views/enterprise/enterprise-admin-dashboard-view.coffee').then(
    (m) => m.default,
  );
};
